import { render } from "./img-pool-form.vue?vue&type=template&id=56e20a22"
import script from "./img-pool-form.vue?vue&type=script&lang=js"
export * from "./img-pool-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__